import { AbstractControlOptions, FormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Directive } from '@angular/core';

@Directive()
export abstract class EaEarningFormBuilder extends PrFormAbstract {
  generate(entity: any) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        id: [entity ? entity.id : null],
        startDate: [entity ? entity.startDate : null, Validators.required],
        endDate: [entity ? entity.endDate : null],
        connaissance: [
          entity && entity.connaissance ? entity.connaissance : 'netMensuel',
          Validators.required,
        ],
        amount: [entity ? entity.amount : null, Validators.required],
        fraisReel: [entity ? entity.fraisReel : null],
      },
      options,
    );
  }

  extract() {
    let dto: any = {
      id: this.emptyIsNull(this.form.value.id),
      startDate: this.emptyIsNull(this.form.value.startDate),
      endDate: this.emptyIsNull(this.form.value.endDate),
      fraisReel: this.emptyIsNull(this.form.value.fraisReel),
    };
    let amount = parseFloat(this.form.value.amount);
    switch (this.form.value.connaissance) {
      case 'netMensuel':
        dto.amount = amount;
        break;
      case 'netAnnuel':
        dto.amount = amount / 12;
        break;
      case 'brutMensuel':
        dto.amount = amount * 0.78;
        break;
      case 'brutAnnuel':
        dto.amount = (amount * 0.78) / 12;
        break;
    }
    return dto;
  }
}
